import Error from "@components/error/error";

const ArtifactSidebarError = () => {
  const title = "An error occurred, we cannot load this content.";
  const description = undefined;

  return (
    <div className="-mt-3 px-6" aria-label="Error sidebar artifact">
      <div className="pt-2">
        <Error title={title} description={description} />
      </div>
    </div>
  );
};

export default ArtifactSidebarError;
